import { useEffect } from 'react';

const useTitle = (title) =>{
    useEffect(() => {
        document.title = `Lounge Bridge | ${title}`
    }, [title]);

    return null;
}

export default useTitle;